"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

(function () {
  var enterModule = require('react-hot-loader').enterModule;

  enterModule && enterModule(module);
})();

var TabPanel = function TabPanel(_ref) {
  var className = _ref.className,
      children = _ref.children,
      index = _ref.index,
      active = _ref.active;
  var classes = (0, _classnames.default)('TabPanel', {
    'TabPanel-active': active
  }, className);
  return _react.default.createElement("div", {
    className: classes,
    role: "tabpanel"
  }, children);
};

TabPanel.propTypes = {
  /** Additional class(es) to add to the component. */
  className: _propTypes.default.string,

  /** The content to render inside of the tab. */
  children: _propTypes.default.node.isRequired,

  /** Whether this panel should be active. Automatically passed from TabContent, do not set manually. */
  active: _propTypes.default.bool,

  /** The index that corresponds to this panel. Automatically passed from TabContainer, do not set manually. */
  index: _propTypes.default.number
};
var _default = TabPanel;
var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = require('react-hot-loader').default;

  var leaveModule = require('react-hot-loader').leaveModule;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(TabPanel, "TabPanel", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Tabs/TabPanel.jsx");
  reactHotLoader.register(_default, "default", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Tabs/TabPanel.jsx");
  leaveModule(module);
})();

;